import { render, staticRenderFns } from "./BpSelect.vue?vue&type=template&id=2280070b&scoped=true&"
import script from "./BpSelect.vue?vue&type=script&lang=js&"
export * from "./BpSelect.vue?vue&type=script&lang=js&"
import style0 from "./BpSelect.vue?vue&type=style&index=0&id=2280070b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280070b",
  null
  
)

export default component.exports